export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0a0e1a] border-t border-amber-500/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 text-center">
        <p className="text-sm text-slate-400 mb-4">
          &copy; {new Date().getFullYear()} PTC Client Hub + EasyQuickFund
        </p>
        <p className="text-xs text-slate-500">
          A Prestigious Companies Network <span className="text-slate-600 mx-1">|</span> Strategic Partner of the Prestigious Travel Club Foundation
        </p>
      </div>
    </footer>
  );
}
